import React, { FunctionComponent } from 'react';
import { ContainerInterface } from '../../interfaces/Container.interface';

const Container: FunctionComponent<ContainerInterface> = (props) => {
  return (
    <div className={`page-container ${props.bgClass}`}>
      <div className="content-wrapper">{props.children}</div>
    </div>
  );
};

export default Container;
